import { render, staticRenderFns } from "./AddSppucLayer.vue?vue&type=template&id=5d61cbb8&scoped=true"
import script from "./AddSppucLayer.vue?vue&type=script&lang=js"
export * from "./AddSppucLayer.vue?vue&type=script&lang=js"
import style0 from "./AddSppucLayer.vue?vue&type=style&index=0&id=5d61cbb8&prod&lang=scss"
import style1 from "./AddSppucLayer.vue?vue&type=style&index=1&id=5d61cbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d61cbb8",
  null
  
)

export default component.exports